import { render, staticRenderFns } from "./ScreenDetails.vue?vue&type=template&id=4a2d2581"
import script from "./ScreenDetails.vue?vue&type=script&lang=js"
export * from "./ScreenDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports